import React, {useRef, useState} from "react";
import {Modal, ModalBody, Tab, Tabs} from "react-bootstrap";
import "./style.scss";
import Withdraw from "./Withdraw";
import Charge from "./Charge";
import {useTranslation} from "react-i18next";
import {ReactComponent as WalletLogo} from "../../../asset/icons/wallet_mo.svg";
import BackButton from "../BackButton";

export default function WalletModal({showModal, closeModal, money, coins}) {
  const backBtnRef = useRef(null)
  const [activeTab, setActiveTab] = useState();
  const {t} = useTranslation()

  const handleClose = () => {
    closeModal()
  }

  return (
    <Modal show={showModal} id="wallet-mo" className="wallet_modal">
      <ModalBody>
        <div className="wallet-modal-container">
          <div className="wallet-modal-header">
            <div ref={backBtnRef}>
              <WalletLogo/>
              <span>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Window')}</span>
            </div>
            <BackButton specialClass='wallet-btn-back' onclickFunction={handleClose}/>
          </div>
          <div className="tab-section">
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(e) => setActiveTab(e)}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Wallet.Tab')}>
                <Charge handleClose={handleClose} money={money} coins={coins}/>
              </Tab>
              <Tab
                eventKey="2"
                className="panel_tab_item"
                title={t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Withdrawal.Tab')}
              >
                <Withdraw handleClose={handleClose} money={money} coins={coins}/>
              </Tab>
            </Tabs>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}


